/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCalendarCheck = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M21.707 17.707 17 22.414l-2.707-2.707 1.414-1.414L17 19.586l3.293-3.293z" />
        <path d="M9 4h6V2h2v2h5v10h-2V6h-3v2h-2V6H9v2H7V6H4v14h8v2H2V4h5V2h2z" />
        <path d="M7 17H5v-2h2zm3 0H8v-2h2zm3 0h-2v-2h2zm3 0h-2v-2h2zm-9-3H5v-2h2zm3 0H8v-2h2zm3 0h-2v-2h2zm3 0h-2v-2h2zm3 0h-2v-2h2zM7 11H5V9h2zm3 0H8V9h2zm3 0h-2V9h2zm3 0h-2V9h2zm3 0h-2V9h2z" />
      </g>
    </g>
  </Icon>
);
export { SvgCalendarCheck as CalendarCheck };
